(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentServiceItemAccessSearch', AgentServiceItemAccessSearch);

    AgentServiceItemAccessSearch.$inject = ['$resource'];

    function AgentServiceItemAccessSearch($resource) {
        var resourceUrl = 'api/_search/agent-service-item-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
